import React, { Component } from "react";
import { connect } from "react-redux";
import { breadcrumbs } from "../../../../actions/appActions";
import { push } from "react-router-redux";
import loginInfo from "../../components/LoginInfo";
import EmailTemplates from "./EmailTemplates";
import DocumentTemplates from "./DocumentTemplates";

class Templates extends Component {
  tabs = [
    { label: "Emaily", value: "email" },
    { label: "Dokumenty", value: "dokument" }
  ];

  getTab() {
    return this.tabs.find((tab) => tab.value === this.props.params.tab);
  }

  componentWillMount() {
    this.props.breadcrumbs([{ label: "Šablony" }]);
    if (this.props.params.tab === undefined) {
      this.props.params.tab = this.tabs[0].value;
    }
  }

  onTabClick = (url, tab) => () => this.props.push(`${url}/sablony/${tab}`);

  render() {
    const { auth } = this.props;
    
    return (
      <div className="templatesPage">
        <div className="pageTabs pageTabs--templates">
          <div className="pageTabs__scroller">
            {this.tabs.map((tab) => {
              return (
                <button
                  key={tab.value}
                  type="button"
                  className={
                    this.getTab().value === tab.value ? "pageTabs__tab pageTabs__tab--active" : "pageTabs__tab"
                  }
                  onClick={this.onTabClick(auth.startUrl, tab.value)}
                >
                  {tab.label}
                </button>
              );
            })}
          </div>
        </div>
        {this.getTab().value === "email" && <EmailTemplates {...this.props} />}
        {this.getTab().value === "dokument" && <DocumentTemplates {...this.props} />}
      </div>
    );
  }
}

export default connect(null, { breadcrumbs, push })(loginInfo(Templates));
